import {
  ITochiChicken,
  ITochiGradientMaskMaterial,
} from "@snackpass/snackpass-types";
import { GradientMaskShader } from "src/utils/Tochi/TochiShaders";
import { ShaderMaterial, TextureLoader, UniformsUtils } from "three";
import TochiMaterial from "./TochiMaterial";
import {
  getColorPos,
  MAX_COLORS,
  MIN_COLORS,
  padColorPosArray,
  stringArrToColor,
  stringToColor,
} from "./utils";

export default class GradientMaskMaterial implements TochiMaterial {
  material?: THREE.ShaderMaterial;
  gradientMask: string;
  colors: string[];
  colorPos: number[];

  decalMask?: string;
  decalColor?: string;

  constructor(props: ITochiGradientMaskMaterial) {
    this.gradientMask = props.gradientMask;
    if (props.colors.length < MIN_COLORS) {
      throw new Error(`There must be at least ${MIN_COLORS} colors`);
    }
    this.colors = props.colors;
    this.colorPos = getColorPos(this.colors, props.colorPos);
    if (props.decalMask && props.decalColor) {
      this.decalMask = props.decalMask;
      this.decalColor = props.decalColor;
    }
  }

  load = async () => {
    const shader = GradientMaskShader(
      this.colors.length,
      !(this.decalMask == null && this.decalColor == null)
    );

    const u = UniformsUtils.clone(shader.uniforms);
    const vs = shader.vertexShader;
    const fs = shader.fragmentShader;

    const loader = new TextureLoader();
    u.mask.value = await loader.load(this.gradientMask);
    u.colors.value = stringArrToColor(this.colors);
    u.colorPos.value = padColorPosArray(this.colorPos, MAX_COLORS);
    u.fresnelColor.value = stringToColor("white");
    if (this.decalMask && this.decalColor) {
      u.decalMask.value = await loader.load(this.decalMask);
      u.decalColor.value = stringToColor(this.decalColor);
    }

    const mat = new ShaderMaterial({
      uniforms: u,
      vertexShader: vs,
      fragmentShader: fs,
    } as any);
    this.material = mat;
  };

  get = async () => {
    if (!this.material) {
      await this.load();
    }
    return this.material!;
  };

  setChicken = (chicken: ITochiChicken) => {
    if (!this.material) return;
    this.material.uniforms.colors.value = stringArrToColor(
      this.colors,
      chicken
    );
    if (this.decalColor) {
      this.material.uniforms.decalColor.value = stringToColor(
        this.decalColor,
        chicken
      );
    }
    this.material.needsUpdate = true;
  };
}
